import _export from "../internals/export";
import _iterate from "../internals/iterate";
import _aCallable from "../internals/a-callable";
import _anObject from "../internals/an-object";
import _getIteratorDirect from "../internals/get-iterator-direct";
var $ = _export;
var iterate = _iterate;
var aCallable = _aCallable;
var anObject = _anObject;
var getIteratorDirect = _getIteratorDirect;
var $TypeError = TypeError;

// `Iterator.prototype.reduce` method
// https://tc39.es/ecma262/#sec-iterator.prototype.reduce
$({
  target: "Iterator",
  proto: true,
  real: true
}, {
  reduce: function reduce(reducer /* , initialValue */) {
    anObject(this);
    aCallable(reducer);
    var record = getIteratorDirect(this);
    var noInitial = arguments.length < 2;
    var accumulator = noInitial ? undefined : arguments[1];
    var counter = 0;
    iterate(record, function (value) {
      if (noInitial) {
        noInitial = false;
        accumulator = value;
      } else {
        accumulator = reducer(accumulator, value, counter);
      }
      counter++;
    }, {
      IS_RECORD: true
    });
    if (noInitial) throw new $TypeError("Reduce of empty iterator with no initial value");
    return accumulator;
  }
});
export default {};